<template>
  <div v-if="reduced || halved" class="locator" :class="{
    ['visible-' + visible]: visible,
    'body__section section--inside section--solid': reduced || halved
  }">
        <div class="title title--2" v-html="title">
        </div>
        <div class="locator__content">
          <div v-if="!reduced" class="title title--4 title--lined">
            <span>{{ order }}</span>
          </div>
          <div class="title title--4 title--lined">
            <span>{{ search }}</span>
          </div>
          <p class="text" v-html="description"></p>

          <div class="locator__fieldset" :class="{'locator__fieldset--loading': loading, 'locator__fieldset--error': error}">
            <div class="locator__field">
              <label for="locator" style="display: none">Renseigner votre adresse</label>
              <vue-google-autocomplete
                country="fr"
                id="locator"
                ref="locator"
                types="(regions)"
                :enable-geolocation="true"
                :placeholder="error ? 'Géolocalisation non activée' : 'Renseigner votre adresse'"
                @keyup.enter="find"
              />
              <span class="locator__fieldset__find" @click="find">
                <svg class="arrow-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48" fill="none" stroke="#F00036" stroke-linecap="round" stroke-width="2" stroke-linejoin="round">
                    <line x1="12.16" y1="24" x2="35.81" y2="24"></line>
                    <polyline points="25.91 14.07 35.84 24 25.91 33.93"></polyline>
                </svg>
              </span>
            </div>
            <button @click="geoloc">
              <svg id="crosshair" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
                  <circle fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2px" cx="23.89" cy="23.85" r="13.26"/>
                  <line fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2px" x1="24.04" y1="33.69" x2="24.04" y2="39.33"/>
                  <line fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2px" x1="33.69" y1="23.96" x2="39.33" y2="23.96"/>
                  <line fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2px" x1="23.96" y1="14.31" x2="23.96" y2="8.67"/>
                  <line fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2px" x1="14.31" y1="24.04" x2="8.67" y2="24.04"/>
              </svg>
            </button>
          </div>
        </div>
  </div>
  <div v-else-if="!reduced && !halved" class="locator" :class="{
    ['visible-' + visible]: visible,
    'section': !reduced && !halved,
  }">
    <div class="container">
      <div class="title title--2" v-html="title"> </div>
      <div class="row center-xs">
        <div class="locator__content col-sm-8 col-lg-5">
          <div v-if="!reduced" class="title title--4 title--lined">
            <span>{{ order }}</span>
          </div>
          <a v-if="order" class="button button--cta" href="https://gazissimo.fr/">Commander</a>
          <div class="title title--4 title--lined">
            <span>{{ search }}</span>
          </div>
          <p class="text" v-html="description"></p>

          <div class="locator__fieldset" :class="{'locator__fieldset--loading': loading, 'locator__fieldset--error': error}">
            <div class="locator__field">
              <label for="locator" style="display: none">Renseigner votre adresse</label>
              <vue-google-autocomplete
                country="fr"
                id="locator"
                ref="locator"
                types="(regions)"
                :enable-geolocation="true"
                :placeholder="error ? 'Géolocalisation non activée' : 'Renseigner votre adresse'"
                @keyup.enter="find"
              />
              <span class="locator__fieldset__find" @click="find">
                <svg class="arrow-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48" fill="none" stroke="#F00036" stroke-linecap="round" stroke-width="2" stroke-linejoin="round">
                    <line x1="12.16" y1="24" x2="35.81" y2="24"></line>
                    <polyline points="25.91 14.07 35.84 24 25.91 33.93"></polyline>
                </svg>
              </span>
            </div>
            <button @click="geoloc">
              <svg id="crosshair" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
                <circle fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2px" cx="23.89" cy="23.85" r="13.26"/>
                <line fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2px" x1="24.04" y1="33.69" x2="24.04" y2="39.33"/>
                <line fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2px" x1="33.69" y1="23.96" x2="39.33" y2="23.96"/>
                <line fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2px" x1="23.96" y1="14.31" x2="23.96" y2="8.67"/>
                <line fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2px" x1="14.31" y1="24.04" x2="8.67" y2="24.04"/>
            </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass">
    @import ../../../common/styles/settings
    @import ../../../common/styles/mixins
    @import ../../../common/styles/animations
    @import locator
    @import locator-vendor
</style>

<script>
import VueGoogleAutocomplete from "./VueGoogleAutocomplete";

export default {
    components: {
        VueGoogleAutocomplete
    },
    props:{
      visible: String,
      reduced: Boolean,
      halved: Boolean,
      title: String,
      order: String,
      search: String,
      description: String,
      button: String
    },
    data() {
        return {
            error: false,
            loading: false
        }
    },
    methods: {
        geoloc () {
            if (navigator.geolocation && Object.values(navigator.geolocation).length) {
                this.loading = true;
                navigator.geolocation.getCurrentPosition(position => {
                    this.getAddressFromCoords(position.coords);
                });
            } else {
                this.error = true;
            }
        },
        getAddressFromCoords(coords) {
            let geocoder = new google.maps.Geocoder();
            let latlng = new google.maps.LatLng(coords.latitude, coords.longitude);
            geocoder.geocode({
                'latLng': latlng
            }, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK) {
                    if (results[1]) {
                        this.$refs.locator.value = results[1].formatted_address;
                    }
                }
                this.loading = false;
            });
        },
        find () {
            const address = this.$refs.locator.$el.value;
            const targetUrl = `https://revendeur.antargaz.fr/search?query=${address}`
            if( address && targetUrl ) {
                window.open(targetUrl);
            }
        }
    }
}
</script>
